import * as AppType from "./types";

export const defaultState: AppType.Store = {
  loading: {
    anomal: "SUCCESS",
    meta: "SUCCESS",
    industryMeta: "SUCCESS",
    filter: "SUCCESS",
    navbar: "SUCCESS"
  },
  anomalyDate: "",
  data: {
    info: [],
    control: [],
    warning: [],
    alert: []
  },
  screener: {
    meta: {
      navbarOptions: [],
      criteriaOptions: {},
      customizedFilterOptions: {},
      fundamentalFilterOptions: {},
      industry: [],
      sector: []
    },
    setup: {
      country: "singapore",
      sector: [],
      industry: [],
      criteria: ["52 Weeks High"],
      minCriteria: {},
      customized: [],
      fundamental: []
    },
    result: [],
    navbar: {}
  }
};
